import React from "react";
import styles from "./style.module.css";
import Image from "../../Assets/whatWeOfferPartner.svg";
import Image1 from "../../Assets/whatWeOfferFreeMarket.svg";
import Image2 from "../../Assets/whatWeOfferSelfProduction.svg";
import Image3 from "../../Assets/whatWeOfferProjects.svg";
import Image4 from "../../Assets/whatWeOfferConsult.svg";

export default function About() {
  return (
    <section className={styles.section} id="whatIsMerx">
      <div className={styles.totalContent}>
        <div className={styles.titleAndLogo}>
          <h2 id="whatWeOffer">O Que a Merx Oferece?</h2>
        </div>

        <div className={styles.rowThree}>
          <div className={styles.card}>
            <div className={styles.cardText}>
              <h3>Parcerias</h3>
              <p className={styles.textOffer}>
                Para resultados eficazes e comissão recorrente.
              </p>
            </div>
            <img src={Image} alt="Ícone ilustrativo de parceria — foguete" />
          </div>

          <div className={styles.card}>
            <div className={styles.cardText}>
              <h3>Autoprodução</h3>
              <p className={styles.textOffer}>
                A autoprodução de energia é a solução ideal para empresas que
                buscam independência energética, economia e sustentabilidade.
              </p>
            </div>
            <img
              src={Image2}
              alt="Ícone ilustrativo de autoprodução solar — turbina e painéis"
            />
          </div>

          <div className={styles.card}>
            <div className={styles.cardText}>
              <h3>Projetos</h3>
              <p className={styles.textOffer}>
                Para tirar seus projetos do papel e se tornar realidade.
              </p>
            </div>
            <img src={Image3} alt="Ícone ilustrativo de projetos de energia" />
          </div>
        </div>

        <div className={styles.rowTwo}>
          <div className={styles.card}>
            <div className={styles.cardText}>
              <h3>Mercado Livre</h3>
              <p className={styles.textOffer}>
                Entrar no Mercado Livre de Energia é a oportunidade perfeita
                para empresas que desejam reduzir custos e ganhar autonomia
                energética.
              </p>
            </div>
            <img
              src={Image1}
              alt="Ícone ilustrativo de mercado livre de energia"
            />
          </div>

          <div className={styles.card}>
            <div className={styles.cardText}>
              <h3>Consultoria</h3>
              <p className={styles.textOffer}>
                Para transformar seus projetos em realidade no mercado de
                energia com uma consultoria especializada.
              </p>
            </div>
            <img
              src={Image4}
              alt="Ícone ilustrativo de consultoria em energia solar"
            />
          </div>
        </div>

        <div className={styles.exploreWrapper}>
          <a
            href="https://wa.me/5581982136133?text=Quero%20contratar%20a%20Merx!"
            className={styles.exploreLink}
          >
            <button className={styles.exploreBtn}>Explore</button>
          </a>
        </div>
      </div>
    </section>
  );
}
